export default __webpack_public_path__ + "static/media/education.c58b6e37.png";